<!-- eslint-disable vue/no-unused-refs -->
<template>
  <base-list-management ref="baseListManagement" :configData.sync="configData">
    <PublicExport
      slot="custom-export"
      v-if="judgePermission('vehicle_list_detail')"
      exportTitle="导出"
      exportTemplate="LeaseOrderSub"
      :getSearchData="searchParams"
      templateCode="vehicle-workbench-ent-rent-sub-order"
      :getSearchCondition="getSearchCondition"
    />
  </base-list-management>
</template>
<script>
import pageConfig from './config'
import { generateExportCondition } from '@/utils/exportUtils.js'

export default {
  props: {
    carId: {
      type: [String, Number],
      default: '',
    },
    modelId: {
      type: [String, Number],
      default: '',
    },
    plateNo: {
      type: String,
      default: '',
    },
  },
  data() {
    const { configData } = pageConfig.call(this)
    return {
      configData,
      // 客户列表
      customerConditionList: [],
    }
  },
  methods: {
    // 搜索按钮
    // eslint-disable-next-line vue/no-unused-properties
    dealWithData(params) {
      const obj = {
        carId: this.carId,
        modelId: this.modelId,
        bizType: 20,
        tabNo: 0,
      }
      Object.assign(params, obj)
      return params
    },
    // 页面跳转
    // eslint-disable-next-line vue/no-unused-properties
    toOrderDetailPage(params) {
      const path = '/vehicle/vehicleManage/detail'
      const query = {
        id: params.id,
        orderType: 'enterChild',
        tabType: 'enterpriseChildOrder',
      }
      this.$router.push({
        path,
        query,
      })
    },
    searchParams() {
      return {
        ...this.$refs.baseListManagement?.getParams() || {},
        carId: this.carId,
      }
    },
    getSearchCondition() {
      const params = this.searchParams()
      // input和日期没有值时不展示，其他没有值时展示全部
      const conditions = this.configData.formData.list.map((item) => {
        const {
          el,
          itemConfig: { label, prop: key },
        } = item
        if (key === 'customerId') {
          item.elConfig.options.list = this.customerConditionList
        }
        const val = params[key]
        const { matchValue, hidden } = generateExportCondition[el](val, item)
        return {
          label,
          key,
          matchValue,
          hidden,
        }
      })
      conditions.push({
        label: '车牌号',
        key: 'carId',
        matchValue: this.plateNo,
        hidden: false,
      })
      return conditions
    },
  },
}
</script>
